<div
  class="hero"
  [ngStyle]="{
    background: 'url(' + imageUrl() + ') 70% / cover no-repeat'
  }"
  id="hero"
>
  <div class="container">
    <div
      class="hero__section row justify-content-center"
      data-aos="fade-down"
      data-aos-duration="1000"
      data-aos-delay="200"
      [class.hero__section--with-breadcrumbs]="config().isBreadCrumbs"
    >
      <p
        class="hero__section-title display display-captions-l"
        [class.hero__section-title-newsroom]="config().isNewsRoom"
      >
        @if (config().isNewsRoom) {
        <i class="ri-time-line"></i>
        }
        {{ config().subpageTitle }}
      </p>

      <h1
        class="hero__section-slogan m-0"
        data-test="hero-slogan"
        [class.hero__section-slogan-newsroom]="config().isNewsRoom"
      >
        {{ config().slogan }}
      </h1>

      @if (config().subSlogan) {
      <p class="hero__section-text m-0 display display-3r">
        {{ config().subSlogan }}
      </p>
      } @if (config().buttonText) {
      <button type="button" class="hero__section-btn btn btn-primary">
        <a (click)="scrollToSection('form')" class="display-button"
          >{{ config().buttonText }}
        </a>
      </button>
      }
    </div>
  </div>
</div>
